<template>
  <div>
    <div style="text-align: right">
      <div style="margin-right: 20px"> 
        {{ $t("organstructure.branchname") }}：
        <el-input
          class="branchname"
          :size="size"
          style="width: 180px; font-size: 12px"
          clearable
          :placeholder="$t('organstructure.inputbranchname')"
          v-model="branchname"
        >
        </el-input>
        <el-button
          style="margin-left: 30px; cursor: pointer"
          :size="size"
          @click="search(branchname)"
          plain
          type="primary"
          >{{ $t("public.query") }}</el-button
        >
        <el-button
          style="margin-left: 15px; cursor: pointer"
          :size="size"
          @click="add"
          type="primary"
          >{{ $t("public.add") }}</el-button
        >
      </div>
    </div>
    <div style="display: flex; flex-direction: row">
      <div>
        <i style="vertical-align: -9%" class="iconfont icon-icon_tab_list"></i>
        <span style="margin-left: 10px; font-size: 12px; font-weight: bold">{{
          $t("organstructure.branchlist")
        }}</span>
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-table
        border
        :size="size"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        max-height="386"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <!-- <el-table-column width="50" type="selection">
				</el-table-column> -->
        <el-table-column
          :label="$t('public.index')"
          type="index"
          width="60"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="branchname"
          :label="$t('organstructure.branchname')"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="branchphonenumber"
          :label="$t('organstructure.branchphonenumber')"
          show-overflow-tooltip
          width="140"
        >
        </el-table-column>
        <el-table-column
          prop="branchfax"
          :label="$t('organstructure.branchfax')"
          show-overflow-tooltip
          width="135"
        >
        </el-table-column>
        <el-table-column
          prop="contacts"
          :label="$t('organstructure.contacts')"
          show-overflow-tooltip
          width="85"
        >
        </el-table-column>
        <el-table-column
          prop="telephone"
          :label="$t('operatormgr.mobileTel')"
          show-overflow-tooltip
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="address"
          :label="$t('organstructure.companyAddress')"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          :label="$t('public.Operation')"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              :size="size"
              type="success"
              @click="modify(scope.$index, scope.row)"
              >{{ $t("public.edit") }}</el-button
            >
            <el-button
              :size="size"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >{{ $t("public.del") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      class="andoffice"
      :title="branchtitle"
      :visible.sync="dialogFormVisible"
      :width="LanguageId == 1 ? '450px' : '530px'"
      :close-on-click-modal="false"
      style="font-size: 14px; text-align: center"
    >
     <el-divider></el-divider>  
      <el-form
        :model="branchofficeInfo"
        :label-position="labelPosition"
        :size="size"
        :label-width="LanguageId == 1 ? '100px' : '170px'"
        :rules="rules"
        ref="branchofficeInfo"
      >
        <el-form-item
          :label="$t('organstructure.corporateName')"
          prop="branchname"
        >
          <el-input
            v-model="branchofficeInfo.branchname"
            :placeholder="$t('organstructure.inputbranchname')"
          ></el-input>
        </el-form-item>
       
        <el-form-item :label="$t('organstructure.phone')">
          <el-input
            v-model="branchofficeInfo.branchphonenumber"
            :placeholder="$t('organstructure.inputbranchphonenumber')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('organstructure.fax')">
          <el-input
            v-model="branchofficeInfo.branchfax"
            :placeholder="$t('organstructure.inputbranchfax')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="公司邮箱：">
						<el-input v-model="branchofficeInfo.email"></el-input>
					</el-form-item> -->
        <el-form-item :label="$t('organstructure.contacts') + '：'">
          <el-input
            v-model="branchofficeInfo.contacts"
            :placeholder="$t('organstructure.inputlinecontacts')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('operatormgr.mobileTel') + '：'"
          prop="telephone"
        >
          <el-input
            v-model="branchofficeInfo.telephone"
            oninput="if(value.length>11)value=value.slice(0,11)"
            onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
            :placeholder="$t('organstructure.inputtelphone')"
          ></el-input>
        </el-form-item>
         <el-form-item :label="$t('organstructure.companyAddress') + '：'">
          <el-input
            v-model="branchofficeInfo.address"
            :placeholder="$t('organstructure.inputbaranchAddress')"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="公司简介：" prop="desc">
						<el-input type="textarea" v-model="branchofficeInfo.companyProfile"></el-input>
					</el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer"  >
        <el-button :size="size" @click="dialogFormVisible = false">{{
          $t("public.cancel")
        }}</el-button>
        <el-button
          :size="size"
          type="primary"
          @click="save('branchofficeInfo')"
          >{{ $t("public.save") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import language from "@/utils/getLanguageId";
import { setVehicles } from "@/utils/auth";
import { mapState } from "vuex";
export default {
  data() {
    return {
      LanguageId: 1,
      branchname: "",
      branchtitle: "",
      labelPosition: "right",
      dialogFormVisible: false,
      tableData: [],
      branchofficeInfo: {
        // branchname: "",
        // branchphonenumber: "",
        // branchfax: "",
        // contacts: "",
        // telephone: "",
        // address: ""
      },
      deleteId: [],
      multipleSelection: [],
      rules: {
        branchname: [
          {
            required: true,
            message: this.$t("organstructure.inputbranchname"),
            trigger: "blur",
          },
        ],
        telephone: [
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("drivermanagement.inputphone"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      operator: (state) => state.user.operator,
      size: (state) => state.app.size,
    }),
  },
  mounted() {
    this.querybranchlist();
    this.LanguageId = language(this.$store.getters.locale);
  },
  methods: {
    //查询分公司列表
    querybranchlist() {
      // const companyID = localStorage.getItem('companyId');
      this.$api
        .queryBranchInfo({
          companyID: this.operator.CompanyId,
        })
        .then((res) => {
          console.log(res);
          if (res.data.length > 0) {
            this.tableData = res.data;
          }
        });
    },
    search(val) {
      this.$api
        .queryBranchInfo({
          companyID: this.operator.CompanyId,
          BranchName: val,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.tableData = res.data;
          }
        });
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      console.log(selection);
      this.deleteId = selection.map((item) => item.branchofficeID);
      console.log(this.deleteId);
    },
    add() {
      this.dialogFormVisible = true;
      this.branchtitle = this.$t("organstructure.addbranch");
      this.branchofficeInfo = {};
      this.$nextTick(() => {
        this.$refs["branchofficeInfo"].clearValidate();
      });
    },
    modify(index, row) {
      console.log(index);
      console.log(row);
      this.branchtitle = this.$t("organstructure.modifybranch");
      this.dialogFormVisible = true;
      this.branchofficeInfo = JSON.parse(JSON.stringify(row));
    },
    open2(message) {
      this.$message({
        message: message,
        type: "success",
      });
    },
    open3(message1) {
      this.$message({
        message: message1,
        type: "warning",
      });
    },
    save(formName) {
      var newValue = this.branchofficeInfo;
      console.log(newValue);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.branchtitle == this.$t("organstructure.addbranch")) {
            this.changebranchstate(newValue, "-1", 1);
          } else if (
            this.branchtitle == this.$t("organstructure.modifybranch")
          ) {
            var newaddId = this.branchofficeInfo.branchofficeID.toString();
            this.changebranchstate(newValue, newaddId, 2);
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    handleDelete(index, row) {
      var newdeleteId = row.branchofficeID.toString();
      var selectbranchinfo = {
        branchname: "",
        branchphonenumber: "",
        branchfax: "",
        contacts: "",
        telephone: "",
        address: "",
      };
      this.$confirm(
        this.$t("organstructure.DeleteBranch"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.changebranchstate(selectbranchinfo, newdeleteId, 3);
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: this.$t("organstructure.Cancelleddeletion"),
          // });
        });
    },
    updatetree() {
      this.$api
        .queryVehicleTreeInfo({
          OperatorID: this.$store.getters.operator.OperatorId,
          CompanyID: this.$store.getters.operator.CompanyId,
        })
        .then((res) => {
          //生成对象，保存到store
          console.log(res);
          console.log(123);
          var tree = {};
          res.vehicles.forEach((element) => {
            element.isChecked = false;
            tree[element.id] = element;
          });
          console.log(res.vehicles);
          this.$store.dispatch("app/updateVehicleTree", {
            tree,
            rootId: res.vehicles[0].id,
          });
          this.$store.dispatch("app/updateVehicleData", res.vehicles);
          setVehicles(JSON.stringify(res.vehicles));
          this.$bus.$emit("initVehicleTree");
        });
    },
    //添加、修改、删除接口调用
    changebranchstate(newbranchinfo, newbranchid, operatevalue) {
      // const companyID = localStorage.getItem('companyId');
      this.$api
        .saveBranchInfo({
          companyID: this.operator.CompanyId,
          OptID: this.operator.OperatorId,
          branchofficeID: newbranchid, //分公司ID（修改、删除时需要）
          branchname: newbranchinfo.branchname,
          branchphonenumber: newbranchinfo.branchphonenumber,
          branchfax: newbranchinfo.branchfax,
          contacts: newbranchinfo.contacts,
          telephone: newbranchinfo.telephone,
          address: newbranchinfo.address,
          email: newbranchinfo.email,
          companyProfile: newbranchinfo.companyProfile,
          operate: operatevalue,
        })
        .then((res) => {
          if (res && res.code == 200) {
            this.dialogFormVisible = false;
            this.querybranchlist();
            this.updatetree();
            if (operatevalue == 1) {
              this.open2(this.$t("public.add_success"));
            } else if (operatevalue == 2) {
              // this.branchofficeInfo = res.data;
              this.open2(this.$t("public.edit_success"));
            } else if (operatevalue == 3) {
              this.open2(this.$t("operatormgr.del_success"));
            }
          } else {
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
  },
};
</script>

 
